import styled from 'styled-components';

export const boxFlex = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
`;

export const ThreeDots = styled.span`
    max-width: ${({ maxWidth }) => maxWidth || '100%'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    box-sizing: border-box;
    display: inline-block;
`;

export const DotForTextAtBeginning = styled.span`
    padding-left: 10px;
    position: relative;
    &:before {
        content: '';
        height: ${({ size }) => size || '3px'};
        width: ${({ size }) => size || '3px'};
        position: absolute;
        top: 50%;
        left: 3px;
        background: ${({ color }) => color || '#4f555e'};
        border-radius: 100%;
        transform: translateY(-50%);
        z-index: 1;
    }
`;

export const StyledPadding = styled.span`
    padding: ${({ padding }) => padding || '0 5px'};
`;
